import Cookie from './Cookie';

export default {
  init() {
    this.cookieContent = document.querySelector('.cookie');
    if (!Cookie.get('termsAndConditions') && this.cookieContent) {
      this.addCookieContent();
      this.eventListener();
    }
  },

  addCookieContent() {
    this.cookieContent.classList.remove('is-hidden');
  },

  removeCookieContent() {
    this.cookieContent.classList.add('is-hidden');
  },

  eventListener() {
    const acceptButton = document.querySelector('.cookie__button');
    acceptButton.addEventListener('click', () => {
      Cookie.set('termsAndConditions', 1, 365);
      this.removeCookieContent();
    });
  },
};
